import { Controller } from "@hotwired/stimulus"

// Simple collapsible content controller using max-height transitions
export default class extends Controller {
  static targets = ["content", "chevron", "button"]

  connect() {
    // Respect aria-expanded if set in markup
    const expanded = this.buttonTarget.getAttribute("aria-expanded") === "true"
    this.isOpen = expanded
    this.update(false)
  }

  toggle() {
    this.isOpen = !this.isOpen
    this.update(true)
  }

  open() {
    this.isOpen = true
    this.update(true)
  }

  close() {
    this.isOpen = false
    this.update(true)
  }

  update(animate) {
    const content = this.contentTarget
    const chevron = this.hasChevronTarget ? this.chevronTarget : null

    if (this.isOpen) {
      if (animate) {
        content.style.maxHeight = content.scrollHeight + "px"
      } else {
        // Large max height for SSR initial open state
        content.style.maxHeight = content.scrollHeight + "px"
      }
      this.buttonTarget.setAttribute("aria-expanded", "true")
      if (chevron) chevron.style.transform = "rotate(180deg)"
    } else {
      content.style.maxHeight = "0px"
      this.buttonTarget.setAttribute("aria-expanded", "false")
      if (chevron) chevron.style.transform = "rotate(0deg)"
    }
  }
}
